import * as yup from 'yup';

import { formFields } from '../../../constants';
import i18n from '../../../i18n';

export const GLN_VALIDATION = yup
  .string()
  .matches(/^\d{13}$/, i18n.t('ERR.gln'))
  .when(`${formFields.GLN}_Required`, {
    is: true,
    then: yup.string().matches(/^\d{13}$/, i18n.t('ERR.gln')).required(i18n.t('ERR.fieldRequired')) });
